import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";
import {ShareTargetStatusEnum} from "./ShareDashboardCB";

export class ShareValidationTargetDTO {
  userId!: number;
  username?: string;
  status!: ShareTargetStatusEnum;
}

class O {
  // Destinatari che non riceverebbero nulla
  invalidTargets!: ShareValidationTargetDTO[];
  // Destinatari che riceverebbero la copia, ma con solo alcune misure: insieme disgiunto dal
  // precedente, e da confermare a parte perché la copia viene comunque creata
  partialTargets!: ShareValidationTargetDTO[];
  warningMessage?: string;
}

/**
 * I Inner Class
 */
class I {
  dashboardId?: number;
  targetUserIds!: number[];
}

/**
 * ValidateShareDraftCB class
 */
export class ValidateShareDraftCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.ValidateShareDraft);
    this.i = new I();
    this.o = new O();
  }

}
